import { DashboardModule, Grid } from '@domain-group/suit-theme'

import { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import type { TemplatePageModel } from '@models/types'

import TemplatePage from './TemplatePage'

interface TemplateGroupProps {
  agencyMarketingPayload: UseAgencyMarketingPayload,
  templateGroup: {
    id: number,
    items: TemplatePageModel[],
    title: string,
  },
}

const TemplateGroup = (props: TemplateGroupProps) => {
  const {
    agencyMarketingPayload,
    templateGroup: {
      id: serviceProductId,
      items,
      title,
    },
  } = props

  return (
    <DashboardModule boxProps={{ marginBottom: 'large' }} title={title}>
      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridAutoRows="1fr"
        gridTemplateColumns="repeat(auto-fill, minmax(250px, 1fr))"
        padding="large"
      >
        {items?.map((templatePage: TemplatePageModel) => (
          <TemplatePage
            key={templatePage.id}
            agencyMarketingPayload={agencyMarketingPayload}
            serviceProductId={serviceProductId}
            templatePage={templatePage}
          />
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default TemplateGroup
